import type { IMessage, IMessageData } from '@/entities';

export * from './message.types';

export class Message implements IMessage {
  id = '';
  title = '';
  subject = '';
  body = '';
  imageUrl = '';
  dateTime = new Date();
  isRead = false;

  constructor(data: IMessageData) {
    Object.assign(this, data);
  }
}
